import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Percentage = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="percentage icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 11C7.76142 11 10 8.76142 10 6C10 3.23858 7.76142 1 5 1C2.23858 1 0 3.23858 0 6C0 8.76142 2.23858 11 5 11ZM5 7.5C5.82843 7.5 6.5 6.82843 6.5 6C6.5 5.17157 5.82843 4.5 5 4.5C4.17157 4.5 3.5 5.17157 3.5 6C3.5 6.82843 4.17157 7.5 5 7.5Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 23C21.7614 23 24 20.7614 24 18C24 15.2386 21.7614 13 19 13C16.2386 13 14 15.2386 14 18C14 20.7614 16.2386 23 19 23ZM19 19.5C19.8284 19.5 20.5 18.8284 20.5 18C20.5 17.1716 19.8284 16.5 19 16.5C18.1716 16.5 17.5 17.1716 17.5 18C17.5 18.8284 18.1716 19.5 19 19.5Z"
    />
    <path
      className={pathClass}
      d="M21.4948 4.32875C22.2286 3.50318 22.1543 2.23904 21.3287 1.5052C20.5032 0.771367 19.239 0.845728 18.5052 1.67129L2.50517 19.6713C1.77134 20.4969 1.8457 21.761 2.67126 22.4948C3.49683 23.2287 4.76097 23.1543 5.49481 22.3287L21.4948 4.32875Z"
    />
  </svg>
)
